export default {
    user: null,
    dancers: {
        loaded: false,
        items: []
    },
    starterTemplates: {
        loaded: false,
        items: []
    },
    ageGroups: {
        loaded: false,
        items: []
    },
    starterTypes: {
        loaded: false,
        items: []
    },
    starterStyles: {
        loaded: false,
        items: []
    },
    events: {
        loaded: false,
        items: []
    },
    registrations: {
        loaded: false,
        items: []
    },
    users: {
        loaded: false,
        items: []
    },
    eventTypes: {
        loaded: false,
        items: []
    },
    starters: {
        loaded: false,
        items: []
    },
    liveStreams: {
        loaded: false,
        items: []
    },
    videoGroups: {
        loaded: false,
        items: []
    },
    dialogs: {
        confirm: {
            active: false,
            headline: '',
            text: '',
            confirmCallback: null,
            cancelCallback: null
        },
        info: {
            active: false,
            headline: '',
            text: '',
            copyTitle: '',
            copyText: '',
            actions: []
        }
    },
    snackBar: {
        active: false,
        timeout: 6000,
        color: '',
        text: ''
    },
    cache: {
        event_registrations: {
            last_viewed_event_id: null
        }
    }
}
